import SaleList from "./SaleList";
const SaleRoutes = [
  {
    path: "/sale/sale-list",
    component: SaleList,
    permission: "Permissions.Sales.View",
  },
];
export default SaleRoutes;
